import styled from 'styled-components';
import { setVh } from 'utils/styles/mixins';
import { layout } from 'utils/styles/theme';

export const Wrapper = styled.div`
    width: 100%;
    height: ${setVh(100)};
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
    pointer-events: none;
    z-index: ${layout.zIndex.modals};
`;
